import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AlertComponent } from '@nx-vigil/core/web/alert/feature';

@Component({
  selector: 'central-root',
  imports: [RouterModule, AlertComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<core-alert /><router-outlet></router-outlet>`,
  styles: [],
})
export class AppComponent {}
